import { forEach } from 'lodash';

const openDetails = (e, isMobile) => {
    const tab = e.currentTarget.parentElement;

    if (isMobile || tab.classList.contains('prd-tab-techspecs')) {
        if (tab.classList.contains('open')) {
            tab.classList.remove('open');
        } else {
            tab.classList.add('open');
        }
    }
};

const openDestinationNotes = (e) => {
    const div = e.currentTarget.parentElement.querySelector(
        '.prd-destination-note'
    );

    if (div.classList.contains('open')) {
        div.classList.remove('open');
    } else {
        div.classList.add('open');
    }
};

const scrollToReviews = (isMobile, reviewsRef) => {
    if (isMobile) reviewsRef.current.classList.add('open');
    reviewsRef.current.scrollIntoView({ behavior: 'smooth' });
};

const scrollToSizeChart = (sizeChartRef) => {
    sizeChartRef.current.classList.add('open');
    sizeChartRef.current.scrollIntoView({ behavior: 'smooth' });
};

const scrollToSection = (e) => {
    const index = Number(e.currentTarget.dataset.index);
    const items = document.querySelectorAll('.prd-tab');

    items[index].classList.add('open');
    items[index].scrollIntoView({ behavior: 'smooth' });
};

const enterFullScreen = (flktyRef) => {
    if (flktyRef) {
        flktyRef.viewFullscreen();
    }
};

const zoomFullscreen = (e, flktyRef) => {
    if (
        document
            .querySelector('.big.flickity-enabled')
            .classList.contains('is-fullscreen') ||
        flktyRef.element.classList.contains('review-img') ||
        flktyRef.element.classList.contains('qanda')
    ) {
        if (e.currentTarget.classList.contains('zoom')) {
            e.currentTarget.classList.remove('zoom');
        } else {
            e.currentTarget.classList.add('zoom');
        }
    }
};

const showOverlay = (e, isMobile) => {
    const overlay = e.currentTarget.querySelector('div');
    overlay.classList.add('overlay');

    if (
        !isMobile &&
        e.currentTarget.classList.contains('carousel-large-cell')
    ) {
        const img = e.currentTarget.querySelector('img');
        img.classList.add('hovered');
    }
};

const hideOverlay = (e, isMobile) => {
    const overlay = e.currentTarget.querySelector('div');
    overlay.classList.remove('overlay');

    if (
        !isMobile &&
        e.currentTarget.classList.contains('carousel-large-cell')
    ) {
        const img = e.currentTarget.querySelector('img');
        img.classList.remove('hovered');
    }
};

const toggleNextElementVisibility = (e) => {
    const element = e.currentTarget.nextElementSibling;

    if (element.classList.contains('open')) {
        element.classList.remove('open');
    } else {
        element.classList.add('open');
    }
};

const handleAbuseTypeChange = (e, reportAbuseFormRef) => {
    e.preventDefault();
    const radioButtons = reportAbuseFormRef.current.querySelectorAll(
        'input[type="radio"]'
    );

    forEach(radioButtons, (r) => {
        r.removeAttribute('checked');
    });
    e.currentTarget.setAttribute('checked', '');
};

export {
    openDetails,
    openDestinationNotes,
    scrollToReviews,
    scrollToSizeChart,
    scrollToSection,
    zoomFullscreen,
    showOverlay,
    hideOverlay,
    toggleNextElementVisibility,
    enterFullScreen,
    handleAbuseTypeChange,
};
